import { ERROR_STATUS, SUCCESS_STATUS } from 'services/api'

const cuilLen = 11

const hasProgressiveChars = (value: string, maxLength = 5): boolean => {
  const valueLower = value.toLowerCase()
  for (let i = 0; i < valueLower.length - (maxLength - 1); i += 1) {
    const subChars = valueLower.slice(i, i + maxLength)
    let isGrowing = true
    let isDecrease = true
    for (let j = 1; j < maxLength; j += 1) {
      if (subChars.charCodeAt(j) !== subChars.charCodeAt(j - 1) + 1) {
        isGrowing = false
      }
      if (subChars.charCodeAt(j) !== subChars.charCodeAt(j - 1) - 1) {
        isDecrease = false
      }
    }
    if (isGrowing || isDecrease) {
      return true
    }
  }
  return false
}
const validCuilsPrefix: string[] = ['20', '23', '24', '25', '26', '27']

const isCuil = (cuil: string): boolean => validCuilsPrefix.includes(cuil.slice(0, 2))

const isValidCuil = (cuil: string): boolean => {
  if (cuil.length !== cuilLen) {
    return false
  }

  const [checkDigit, ...rest] = cuil.split('').map(Number).reverse()

  const total = rest.reduce((acc, cur, index) => acc + cur * (2 + (index % 6)), 0)

  const mod11 = cuilLen - (total % cuilLen)

  if (mod11 === cuilLen) {
    return checkDigit === 0
  }

  if (mod11 === 10) {
    return false
  }

  return checkDigit === mod11
}

const isSuccessStatus = (...args: number[]) => args.every((arg: number) => SUCCESS_STATUS.includes(arg))
const isInternalErrorStatus = (...args: number[]) => args.every((arg: number) => ERROR_STATUS.includes(arg))

export { isValidCuil, hasProgressiveChars, isCuil, isSuccessStatus, isInternalErrorStatus }
